import React from 'react';
import PropTypes from 'prop-types';
import Price from '../../Price';
import StockLabel from '../../StockLabel';

import clsx from 'clsx';

import { useTranslation } from 'react-i18next';

const CustomPageDetailContentEcMiddleLayoutItem = (props) => {

  let {
    pageBlockItem,
    columns,
    columnsSp
  } = props;

  const getColClass = () => {
    let col_class;
    switch(parseInt(columns)) {
      case 1:
        col_class = 'col-md-12';
        break;
      case 2:
        col_class = 'col-md-6';
        break;
      case 3:
        col_class = 'col-md-4';
        break;
      case 4:
        col_class = 'col-md-3';
        break;
      case 5:
        col_class = 'col-md-2-5';
        break;
      case 6:
        col_class = 'col-md-2';
        break;
      default:
        col_class = 'col-md';
        break;
    }
    switch(parseInt(columnsSp)) {
      case 1:
        col_class += ' col-sm-12 col-12';
        break;
      case 2:
        col_class += ' col-sm-6 col-6';
        break;
      case 3:
        col_class += ' col-sm-4 col-4';
        break;
      case 4:
        col_class += ' col-sm-3 col-3';
        break;
      case 5:
        col_class += ' col-sm-2-5 col-2-5';
        break;
      case 6:
        col_class += ' col-sm-2 col-2';
        break;
      default:
        col_class += ' col-sm col';
        break;
    }
    return col_class;
  };

  // console.log('pageBlockItem CustomPageDetailContentEcMiddleLayoutItem',pageBlockItem)
  let {t} = useTranslation('application');

  return (
    <li className={clsx('product-item flex-column align-items-stretch',getColClass())}>
      <div className="img" data-mh="mh_01">
        <a target="_blank" href={pageBlockItem.itemUrl}>
          <span><img src={pageBlockItem.itemImageUrl}/></span>
        </a>
        {/*// ====== Disable modal support for first release
          <div className="m_previewBtn"><a data-toggle="modal"
                                            data-target={"#item_modal_" + pageBlockItem.pageBlockItemId}>プレビュー</a>
          </div>
        */}
      </div>
      <div className="dtl" data-mh="mh_02">
        <p className="ttl"><span><a target="_blank" href={pageBlockItem.itemUrl}>{pageBlockItem.itemName}</a></span></p>
        <div className="subWrap">
          {pageBlockItem.extendProperties.productSku && <p className="subTxt" >{pageBlockItem.extendProperties.productSku}</p>}
          <p className="subTxt"><a href={pageBlockItem.extendProperties.itemCompanyUrl}>{pageBlockItem.extendProperties.itemCompanyName}</a></p>
          <p className="price">
            {pageBlockItem.extendProperties.itemDiscounted &&
              <React.Fragment>
                <del><Price currency={'JPY'} price={pageBlockItem.extendProperties.itemDiscountedOriginalPrice} openPrice={pageBlockItem.extendProperties.openPrice}/></del>
                <br />
              </React.Fragment>
            }
            <span className={pageBlockItem.extendProperties.itemDiscounted ? "m_txt s_cpn" : "m_txt"}>
                <span className="em"><Price currency={'JPY'} price={pageBlockItem.extendProperties.itemPrice} openPrice={pageBlockItem.extendProperties.openPrice}/></span>
                <span className="sub">(税込)</span>
              </span>
            {pageBlockItem.extendProperties.itemDiscounted && <span className="m_badge">10%OFF</span>}
          </p>
          {pageBlockItem.itemDescription && <p className="subTxt">{pageBlockItem.itemDescription}</p>}
          <span className="subTxt"><StockLabel numberOfStocks={pageBlockItem.extendProperties.numberOfStocks} salesMethodMaker={pageBlockItem.extendProperties.salesMethodMaker} salesMethodLabel={pageBlockItem.extendProperties.salesMethodLabel}/></span>
          <p className="subTxt">{pageBlockItem.extendProperties.shippingDate}</p>
          {pageBlockItem.extendProperties.shopName &&
            <p>
              <a href={pageBlockItem.extendProperties.shopUrl}>
                <i className="c-fa-shop"></i>{pageBlockItem.extendProperties.shopName}
              </a>
            </p>
          }
        </div>
      </div>
      <div className="btnWrap mt-auto" data-mh="mh_03">
        {pageBlockItem.extendProperties.itemBuyUrl &&
          <a className="btn btn-primary btn-block btn-lg text-wrap" target="_blank" href={pageBlockItem.extendProperties.itemBuyUrl}>
            <i className="c-fa-cart s_yellow"></i> {t('common.viewPurchase')}
          </a>
        }
      </div>
    </li>
  );
};

CustomPageDetailContentEcMiddleLayoutItem.propTypes = {
  pageBlockItem: PropTypes.any.isRequired,
  columns: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  columnsSp: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
};

export default CustomPageDetailContentEcMiddleLayoutItem;
